export const LibraryColumns = [
  "Scenario",
  "Categories",
  "Framework",

  // "Source",
];

export const librayColumnWidths = [600, 400, 150, 200];

export const HEADER_TABLE_NAME_MAP = {
  Id: "id",
  Scenario: "description",
  Categories: "categories_id",
  Source: "source_type",
  Framework: "applicable_framework_name",
};
